import React from 'react';

import DownloadAppPopup from 'components/no-auth/common/Popups/DownloadAppPopup';
import ErrorPopup from 'components/no-auth/common/Popups/ErrorPopup';
import QRCodePopup from 'components/no-auth/common/Popups/QRCodePopup';

import { createInvitedUsersData } from 'helpers/api';

const getPureValue = (prefix) => {
    return prefix.replace(/\D+/g, '');
};

export const referralClickHandler = async (form, popupRef, inviteCode, lang, isMobileDevice, page, isUSAOnly, popupErrorText) => {
    const purePhonePrefix = getPureValue(form?.fields?.phone_prefix?.value);
    const phoneCountry = form?.fields?.phone_country?.value;
    const phoneNumber = form?.fields?.phone_number?.value;
    const response = await createInvitedUsersData(phoneNumber, inviteCode, lang, page);

    if (response.code === 0) {
        if (isUSAOnly) {
            if (response.countryA2 !== 'US') {
                popupRef.current?.open(<ErrorPopup popupRef={popupRef} text={popupErrorText} btnText={'Ok'} />);
                return;
            }
        }
        if (isMobileDevice) {
            popupRef.current?.open(<DownloadAppPopup popupRef={popupRef} />);
        } else {
            popupRef.current?.open(<QRCodePopup popupRef={popupRef} />);
        }
        const invitedUserData = {
            prefix: purePhonePrefix,
            phone: phoneNumber,
            country: response.countryA2.toLowerCase() || phoneCountry,
        };
        sessionStorage?.setItem('invitedUserData', JSON.stringify(invitedUserData));
    } else {
        popupRef.current?.open(<ErrorPopup popupRef={popupRef} text={response?.message} btnText={'Ok'} />);
    }
};
